import { useCallback } from 'react';
import { toast } from 'react-toastify';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useCompany from 'src/hooks/useCompany';
import useConfirm from 'src/hooks/useConfirm';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import useRedirect from 'src/hooks/useRedirect';

const CreateDocument = () => {
  const { confirm } = useConfirm();
  const { company } = useCompany();
  const { getUrl, redirect } = useRedirect();
  const {
    isReviewPanelLoading,
    poNumber,
    reviewPoValidations,
    docNumber,
    selectedSupplier,
    createOcrDocument,
    isCreateAndConfirmDocumentLoading,
    ocrPreviewDocument,
    closeReviewModal,
    refreshPage,
    getOcrRecordCount,
    validationMessages,
    isMergeAttachmentLoading,
  } = useInvoiceScanManager();

  const permission723 = reviewPoValidations.isPoRequiredToCreateInvoice;
  const poMatchStatus = reviewPoValidations.matchStatus;

  const handleCreateOcrDocument = useCallback(async () => {
    const reqBody = {
      companyId: Number(company.companyId),
      invoiceNumber: docNumber.value,
      poNumber: poNumber.value,
      supplierId: selectedSupplier.supplierId,
      poId: Number(reviewPoValidations.poId) || null,
      isOnlineSupplier: selectedSupplier.isOnlineSupplier,
    };
    const res = await createOcrDocument({
      attachmentId: ocrPreviewDocument?.attachId as number,
      body: reqBody,
    });
    toast.success('Invoice created Successfully!');
    redirect(getUrl('invoiceDetails')(res.invoiceId, res.poId), false, true);
    closeReviewModal();
    refreshPage();
    getOcrRecordCount();
  }, [
    company.companyId,
    docNumber.value,
    poNumber.value,
    selectedSupplier.supplierId,
    selectedSupplier.isOnlineSupplier,
    reviewPoValidations.poId,
    createOcrDocument,
    ocrPreviewDocument?.attachId,
    redirect,
    getUrl,
    closeReviewModal,
    refreshPage,
    getOcrRecordCount,
  ]);

  const handleCreateDoc = useCallback(async () => {
    if (
      !permission723 &&
      (poMatchStatus === 'InvalidMatch' ||
        poMatchStatus === 'NoMatch' ||
        poMatchStatus === 'PoNumberNotFound' ||
        poMatchStatus === 'MultipleMatch')
    ) {
      const isCreateAccepted = await confirm({
        title: 'Create Confirmation',
        content: (
          <div>
            You entered an invalid PO #. Please confirm you want to create an invoice independent of
            the provided PO #.
          </div>
        ),
        confirmButtonText: 'Confirm',
      });
      if (isCreateAccepted) {
        handleCreateOcrDocument();
      }
    } else {
      handleCreateOcrDocument();
    }
  }, [confirm, handleCreateOcrDocument, poMatchStatus, permission723]);

  return (
    <PopUp
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper type="Error" contents={validationMessages.confirmPopUpMessage} />
        </div>
      }
      show={Boolean(validationMessages.confirmPopUpMessage?.length)}
      anchorAlign={{ horizontal: 'center', vertical: 'top' }}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
    >
      <Button
        color="success"
        disabled={
          validationMessages.confirmPopUpMessage.length > 0 ||
          isReviewPanelLoading ||
          isCreateAndConfirmDocumentLoading ||
          isMergeAttachmentLoading
        }
        onClick={handleCreateDoc}
      >
        Confirm and Create Document
      </Button>
    </PopUp>
  );
};

export default CreateDocument;
